module.exports = __webpack_public_path__ + "img/Eduzz-6-es.8192452b.png";